import { EmptyContent } from '@ztechapps/webui.util'
import { SeeOurProductsButton } from '../../../../components/SeeOurProductsButton'
import React from 'react'

export const OrderListEmptyContent = ({ tabName }) => {
  return (
    <EmptyContent
      icon="list"
      message={`No ${tabName} orders.`}
      subMessage="You dont have any orders, browse our products to add one."
      action={<SeeOurProductsButton />}
    />
  )
}
